import {LanguageType}		from './type';

import fr					from './fr';
// import en					from './en';

const langFile: Record<string, LanguageType> = {fr};

export default (lang: string) => {
	if (!langFile[lang])
		return langFile['fr'];
	return langFile[lang];
};
